import React from 'react';

const CookingPotIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 9h16" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 9c0-3.314 2.686-6 6-6s6 2.686 6 6" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 9v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9" />
    </svg>
);

export default CookingPotIcon;
